import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import AdRail from './AdRail';
import './PageLayout.css';

const PageLayout = ({ children }) => {
  const location = useLocation();
  const { t } = useTranslation();

  const navItems = [
    { path: '/',               label: t('home'),       icon: 'home' },
    { path: '/vocabularyList', label: t('vocabulary'), icon: 'book' },
    { path: '/progress',       label: t('progress'),   icon: 'chart' },
    { path: '/settings',       label: t('settings'),   icon: 'settings' },
  ];

  return (
    <div className="app-shell">
      <AdRail position="left" />

      <div className="page-layout">
        <nav className="top-nav" aria-label="Primary">
          {navItems.map((item) => {
            const active = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`top-nav-item${active ? ' active' : ''}`}
                aria-label={item.label}
                aria-current={active ? 'page' : undefined}
              >
                <Icon name={item.icon} size={22} />
                <span className="top-nav-label">{item.label}</span>
              </Link>
            );
          })}
        </nav>
        <div className="page-content">
          {children}
        </div>

        <footer className="site-footer">
          <div className="site-footer-links">
            <Link to="/privacy-policy" className="site-footer-link">{t('privacyPolicy')}</Link>
            <Link to="/contact" className="site-footer-link">{t('contactUs')}</Link>
            <Link to="/aboutus" className="site-footer-link">{t('aboutUs')}</Link>
            <Link to="/yki-guide" className="site-footer-link">{t('ykiGuide')}</Link>
            <Link to="/faq" className="site-footer-link">{t('faq')}</Link>
          </div>
          <a
            href="https://www.buymeacoffee.com/ykitest"
            target="_blank"
            rel="noopener noreferrer"
            className="site-footer-coffee"
          >
            <Icon name="coffee" size={16} />
            {t('buyMeACoffee')}
          </a>
          <p className="site-footer-copy">© {new Date().getFullYear()} YKI Testi · Free Finnish language test preparation</p>
        </footer>
      </div>

      <AdRail position="right" />
    </div>
  );
};

export default PageLayout;
